import { Component, Input } from '@angular/core';
import { WagtailFullBleedSliderItemInterface } from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-full-bleed-slider-caption',
    templateUrl: './caption.component.html',
    styleUrls: ['./caption.component.scss'],
    standalone: false
})
export class CaptionComponent {
  @Input() slide?: WagtailFullBleedSliderItemInterface
}
